import React from 'react'

/**
 * Render nothing.
 * @param _props Unused properties
 * @return React component
 */
export const Noop = <P extends {}>(_props: P) => <></>
